import { useDialog } from '@/core/dialogsystem/useDialog';
import SupportMeasureReportDialog from '@/core/supportMeasures/SupportMeasureReportDialog.vue';
import type { ISupportMeasureReportAvailableContent } from '@/interfaces';
import type { ISupportMeasureReportOptions } from 'common/interface/support-measure-report.interface';

interface ISupportMeasureReportDialogComposable {
  /** Opens "Förderbericht erstellen" with the content options the report has; the chosen options go to `onDownload`. */
  showReportDialog: (availableContent: ISupportMeasureReportAvailableContent) => void;
}

export const useSupportMeasureReportDialog = (
  onDownload: (options: ISupportMeasureReportOptions) => void,
): ISupportMeasureReportDialogComposable => {
  const reportDialog = useDialog({ component: SupportMeasureReportDialog, props: { onDownload } });

  return { showReportDialog: (availableContent) => void reportDialog.show(availableContent) };
};
